import form from "./components/form";
import TableNode from "./components/table";
import CustomNode from "./components/custom";
import Layout from "./components/layout";

export const nodeRegistry: any = {
  ...Layout,
  ...form,
  ...TableNode,
  ...CustomNode
};

export default nodeRegistry;